import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {useSelector} from "react-redux";
import {getAppData} from "../../store/slices/appSlice";
import {getSelectedCustomer, getUserConfigurations} from "../../store/slices/userConfigurationsSlice";
import CONST from "../../config/CONST";
import {getFinancialConfiguration} from "../../store/slices/financialConfigurationsSlice";

const DebugTable = () => {

    const appData = useSelector(getAppData);
    const selectedCustomer = useSelector(getSelectedCustomer);
    const selectedVehicleType = appData.input.vehicleType || appData.touchpointConfig.defaults.vehicleCondition;
    const userConfigurations = useSelector(getUserConfigurations);
    const financialProductConfiguration = useSelector(getFinancialConfiguration);

    const [userConfigurationForEIM, setUserConfigurationForEIM] = useState(null);
    const [showDebug, setShowDebug] = useState(false);

    useEffect(() => {
        if(userConfigurations && appData && selectedCustomer && selectedVehicleType && appData.input.EIM) {
            setUserConfigurationForEIM( userConfigurations.find( c => c.EIM === appData.input.EIM && c.selectedProduct && c.vehicleType === selectedVehicleType && c.customer === selectedCustomer));
        }
    }, [userConfigurations, selectedCustomer, appData, selectedVehicleType]);



    const onToggleBtnClick = () => {
        setShowDebug(!showDebug);
    }

    if(!appData || !userConfigurationForEIM || !financialProductConfiguration) {
        return null;
    }

    if(!appData.config.debug) {
        return null;
    }

    if (process.env.REACT_APP_ENV === 'production') {
        return null;
    }


    return (
        <div className={`${CONST.CSS_NAMESPACE}DebugTable`}>

            <h1>DEBUG</h1>

            <button onClick={onToggleBtnClick}>Debug (dev only) <small>{showDebug ? '▲' : '▼'}</small></button>
            <div style={{'display': showDebug ? 'block' : 'none'}}>
                { appData && appData.config ? <DebugTableItem title={'Config'} obj={appData.config}/> : <></> }
                { appData && appData.input ? <DebugTableItem title={'Input'} obj={appData.input}/> : <></> }
                { appData && userConfigurationForEIM ? <DebugTableItem title={'User configuration'} obj={userConfigurationForEIM}/> : <></> }
                { financialProductConfiguration ? <DebugTableItem title={'Financial Product Configuration Results'} obj={financialProductConfiguration}/> : <></> }
            </div>
        </div>
    );
}

export default DebugTable;



const DebugTableItem = (props) => {
    const {
        title,
        obj
    } = props;

    if(!obj) {
        return null;
    }

    return (
        <>
            { title && <h4>{title}</h4> }
            {/*{<pre>{JSON.stringify(obj)}</pre>}*/}
            <table>
                <tbody>
                { Object.entries(obj).map(([key, value], i) => {


                    return (
                        <tr key={i}>
                            <td>{key}</td>
                            <td>{
                                value
                                    ?
                                        (typeof value === 'object')
                                            ?
                                                <DebugTableItem obj={value} />
                                            :
                                                (typeof value === 'boolean')
                                                    ?
                                                        JSON.stringify(value)
                                                    :
                                                        value
                                    :
                                        ''
                            }</td>
                        </tr>
                    );
                }) }
                </tbody>
            </table>
        </>
    );

}
DebugTableItem.propTypes = {
    title: PropTypes.string,
    obj: PropTypes.any,
}